export const FETCH_COLLEGE_DASHBOARD_REQUEST = 'FETCH_COLLEGE_DASHBOARD_REQUEST';
export const FETCH_COLLEGE_DASHBOARD_SUCCESS = 'FETCH_COLLEGE_DASHBOARD_SUCCESS';
export const FETCH_COLLEGE_DASHBOARD_FAILURE = 'FETCH_COLLEGE_DASHBOARD_FAILURE';
export const FETCH_COLLEGE_ANALYTICS_REQUEST = 'FETCH_COLLEGE_ANALYTICS_REQUEST';
export const FETCH_COLLEGE_ANALYTICS_SUCCESS = 'FETCH_COLLEGE_ANALYTICS_SUCCESS';
export const FETCH_COLLEGE_ANALYTICS_FAILURE = 'FETCH_COLLEGE_ANALYTICS_FAILURE';